import { createSlice } from '@reduxjs/toolkit';
import type { State } from '@/reducers/types';
import { getKbIds, updateKbId } from './actions';
import { KbId } from '@/types';
import { logout } from '@/features/auth';

export interface KbIdsState {
  kbIds: KbId[] | null;
}

const initialState: KbIdsState = {
  kbIds: null,
};

export const { name, reducer } = createSlice({
  name: 'kbIds',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getKbIds.fulfilled, (state, action) => {
        state.kbIds = action.payload;
      })
      .addCase(updateKbId.fulfilled, (state, action) => {
        if (state.kbIds) {
          const idxToUpdate = state.kbIds.findIndex(
            (kbId) => kbId.id === action.payload.id,
          );
          if (idxToUpdate !== -1) {
            state.kbIds[idxToUpdate] = action.payload;
          }
        }
      })
      .addCase(logout.fulfilled, () => initialState);
  },
});

export const selectKbIds = (state: State) => state[name].kbIds;
